// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import publicCode from "./public";
import axios from "./public/axiosdefault";
import IndexApi from "./public";
import "@/assets/css/global.css";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import moment from "moment";
import XLSX from "xlsx";
import { Excel } from "antd-table-saveas-excel";
import "moment/locale/zh-cn";
import API from "@/public/api";
//rsa加密解密
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import {
  Divider,
  Anchor,
  List,
  Radio,
  popover,
  LocaleProvider,
  Tree,
  Upload,
  card,
  InputNumber,
  TimePicker,
  DatePicker,
  Transfer,
  Popconfirm,
  Tabs,
  message,
  Button,
  Table,
  Form,
  Select,
  Input,
  Icon,
  Checkbox,
  Tooltip,
  AutoComplete,
  Cascader,
  Row,
  Col,
  Layout,
  Breadcrumb,
  Menu,
  Modal,
  Dropdown,
  Avatar
} from "ant-design-vue"; //按需载入组件
import VueBarcode from "@xkeshi/vue-barcode"; //导入条形码插件
import srmSearch from "@/components/srm-search/srm-search";
import srmBaseDetail from "@/components/srm-detailMes/srm-baseDetail";
import srmUpload from "@/components/srm-detailMes/srm-upload";
import srmUploadUrl from "@/components/srm-detailMes/srm-upload-url";
import srmTimeSign from "@/components/srm-sign/srm-time-sign";
import srmMonthPicker from "@/components/srm-search/srm-month-picker";
import printerModal from "@/components/modal/printerModal";
import { getSystemName } from "@/assets/js/setting";
Vue.component("barcode", VueBarcode); //mockjs引入 数据模拟
//import Mock from './mock'
//import 'moment/locale/zh-cn';
moment.locale("zh-cn");
Vue.config.productionTip = false;
Vue.prototype.$message = message;
// Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;
//大写API 存分类 信息
Vue.prototype.$api = API.apis;
Vue.prototype.API = API;
Vue.prototype.moment = moment;
Vue.prototype.XLSX = XLSX;
Vue.prototype.Excel = Excel;
Vue.prototype.JSEncrypt = JSEncrypt;
// 自定义组件
Vue.component("srmSearch", srmSearch);
Vue.component("srmBaseDetail", srmBaseDetail);
Vue.component("srmUpload", srmUpload);
Vue.component("srmUploadUrl", srmUploadUrl);
Vue.component("srmTimeSign", srmTimeSign);
Vue.component("srmMonthPicker", srmMonthPicker);
Vue.component("printerModal", printerModal);
// ant design组件
const antList = [
  Divider,
  Anchor,
  List,
  Radio,
  popover,
  LocaleProvider,
  Tree,
  Upload,
  card,
  InputNumber,
  TimePicker,
  DatePicker,
  Transfer,
  Popconfirm,
  Tabs,
  message,
  Button,
  Table,
  Form,
  Select,
  Input,
  Icon,
  Checkbox,
  Tooltip,
  AutoComplete,
  Cascader,
  Row,
  Col,
  Layout,
  Breadcrumb,
  Menu,
  Modal,
  Dropdown,
  Avatar
];
for (let component of antList) {
  Vue.use(component);
}

// 设置项目title
const systemName = getSystemName();
document.title = systemName.title;

const ramda = require("ramda");
global.R = ramda;
global.P = publicCode;
global.axios = axios;

global.U = IndexApi.userInfo; //登录后用户信息
global.L = IndexApi.RouterList; //左侧列表数据
//vuex 获取用户状态信息 U.entityStatus
if (U.token) {
  store.dispatch("userInfo/getEntityStatus");
  store.dispatch("registInfo/getRegistInfo");
}
/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  router,
  store,
  data: function() {
    return {
      zh_CN
    };
  },
  components: { App },
  template: '<a-locale-provider :locale="zh_CN"><App/></a-locale-provider>'
});



// WEBPACK FOOTER //
// ./src/main.js